import { ActionHandler, ActionKey, MenuItem } from '../../Types'
import { AlmanacFile, HandbookItemDocument, HandbookItemFolder } from 'types'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'
import { Project } from 'api/clients/ProjectClient'
import { useModals } from 'almanac-ui/Modal'
import { Share } from 'almanac-ui/icons'

const createSharable = (label: string = '') => [{ key: ActionKey.share, textValue: label, Icon: Share } as const]

interface Shareable {
  shareable: MenuItem[]
  handleShareable: ActionHandler
}

export const useShareable = ({
  folder,
  document,
}: {
  folder?: HandbookItemFolder | Project | AlmanacFile | null
  document?: HandbookItemDocument
}): Shareable => {
  const { openModal } = useModals()

  const handleShareable = (actionKey: ActionKey) => {
    if (actionKey !== ActionKey.share) return false

    if (folder) {
      openModal(ShareSheet, {
        file: {
          id: folder?.key || folder.id.toString(),
          type: 'folder',
        },
      })
    }

    if (document) {
      openModal(ShareSheet, {
        file: {
          id: document.key,
          type: 'article',
        },
      })
    }

    return true
  }

  return {
    shareable: createSharable('Share'),
    handleShareable,
  }
}
